import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { useCookies } from 'react-cookie';
import config from './Componentes/config';
import useAuthRedirect from "./Componentes/auth";
import { registrarLog } from './Componentes/logService';
import Sidebar from './SideBar';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { exportarAPDF, exportarAExcel, mostrarModalExportacion } from './Componentes/exportUtils';
import { getEmpresaByCodigo } from './Componentes/empresasConfig';
import ColacionesBot from './Componentes/ColacionesBot';

const cardImages = {
    DAFA: "/img/dafaLogo.png",
    FUGA: "/img/fugarLogo.png",
    INVE: "/img/idafaLogo.png",
    TRAN: "/img/extasisLogo.png",
    NIDI: "/img/nidiamLogo.png"
};

function Colaciones() {
    useAuthRedirect();
    const [cookies] = useCookies(['selectedCard']);
    const imageUrl = cardImages[cookies.selectedCard];

    // Estados para colapsar menús
    const [isComponentsCollapsed, setIsComponentsCollapsed] = useState(true);
    const [isUtilitiesCollapsed, setIsUtilitiesCollapsed] = useState(true);
    const [isInventario, setisIventatioCollapsed] = useState(true);
    const [isPrevencion, setisPrevencionCollapsed] = useState(true);
    const [isLogistica, setisLogisticaCollapsed] = useState(true);
    const [isContabilidadCollapsed, setIsContabilidadCollapsed] = useState(true);
    const [isAdministracionCollapsed, setIsAdministracionCollapsed] = useState(true);

    const toggleCollapse = (collapseSetter) => {
        collapseSetter(prev => !prev);
    };

    const idEmpresa = cookies.idEmpresa;
    // El backend verifica el permiso del módulo, así que todas las llamadas
    // deben identificar al usuario.
    const userId = cookies.userId;

    // Estados del componente
    const [trabajadores, setTrabajadores] = useState([]);
    const [idTrabajadorSeleccionado, setIdTrabajadorSeleccionado] = useState('');
    const [nombreTrabajadorSeleccionado, setNombreTrabajadorSeleccionado] = useState('');
    const [seleccion, setSeleccion] = useState(true);
    const [modoVisitas, setModoVisitas] = useState(false);

    // Estados del formulario
    const [fechaEntrega, setFechaEntrega] = useState('');
    const [tipoColacion, setTipoColacion] = useState('');
    const [nombreVisitante, setNombreVisitante] = useState('');

    // Estados para listado
    const [listadoColaciones, setListadoColaciones] = useState([]);
    const [listadoColacionesFiltradas, setListadoColacionesFiltradas] = useState([]);

    // Estados para filtro mensual
    const [mesSeleccionado, setMesSeleccionado] = useState(0); // 0 = TOTAL
    const [anioSeleccionado, setAnioSeleccionado] = useState(new Date().getFullYear());
    const [verTodosTrabajadores, setVerTodosTrabajadores] = useState(false);
    const [tipoDatos, setTipoDatos] = useState('trabajadores'); // 'trabajadores' o 'trabajadores_visitas'

    // Resumen del mes en curso de toda la empresa (trabajadores + visitas)
    const [resumenMes, setResumenMes] = useState({ normal: 0, fria: 0 });

    const getEmpresaName = (card) => getEmpresaByCodigo(card).nombre;

    const [empresa, setEmpresa] = useState(getEmpresaName(cookies.selectedCard));

    const seleccionTrue = (ID, nombre) => {
        setIdTrabajadorSeleccionado(ID);
        setNombreTrabajadorSeleccionado(nombre);
        setSeleccion(true);
        cargaColaciones(ID);
    };

    const getTrabajadores = () => {
        Axios.get(`${config.API_URL}/getTrabajadores?id=${idEmpresa}&estado=Vigente`)
            .then((response) => {
                setTrabajadores(response.data);
                console.log("Trabajadores cargados:", response.data);
            })
            .catch((error) => {
                console.error("Error al obtener trabajadores:", error);
            });
    };

    const RegistraColacion = async () => {
        // Validación diferente según sea visita o trabajador
        if (modoVisitas) {
            if (!nombreVisitante || !fechaEntrega || !tipoColacion) {
                Swal.fire({
                    title: 'Campos incompletos',
                    text: 'Por favor complete todos los campos requeridos para la visita.',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }
        } else {
            if (!idTrabajadorSeleccionado || !fechaEntrega || !tipoColacion) {
                Swal.fire({
                    title: 'Campos incompletos',
                    text: 'Por favor complete todos los campos requeridos.',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }
        }

        try {
            await Axios.post(`${config.API_URL}/registraColacion`, {
                ID_Trabajador: modoVisitas ? null : idTrabajadorSeleccionado,
                FechaEntrega: fechaEntrega,
                TipoColacion: tipoColacion,
                EsVisita: modoVisitas ? 1 : 0,
                NombreVisita: modoVisitas ? nombreVisitante : null,
                UsuarioCrea: cookies.usuario,
                userId
            });

            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Colaciones',
                Detalle: modoVisitas
                    ? `Registro de colación para visita: ${nombreVisitante}`
                    : `Registro de colación para trabajador ID: ${idTrabajadorSeleccionado}`,
                Estado: 'Éxito'
            });

            if (modoVisitas) {
                Swal.fire({
                    title: '¡Éxito!',
                    text: 'La colación para visita ha sido registrada correctamente.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => {
                    cargaColacionesVisitas();
                    limpiarFormulario();
                });
            } else {
                Swal.fire({
                    title: '¡Éxito!',
                    text: 'La colación ha sido registrada correctamente.',
                    icon: 'success',
                    showDenyButton: true,
                    confirmButtonText: 'Registrar otra',
                    denyButtonText: 'Importar a otros trabajadores',
                    cancelButtonText: 'Finalizar'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        limpiarFormulario();
                    } else if (result.isDenied) {
                        mostrarModalImportacion();
                    } else {
                        cargaColaciones(idTrabajadorSeleccionado);
                        limpiarFormulario();
                    }
                });

                cargaColaciones(idTrabajadorSeleccionado);
            }

        } catch (error) {
            console.error("Error al registrar colación:", error);

            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Colaciones',
                Detalle: modoVisitas
                    ? `Error al registrar colación para visita: ${nombreVisitante} - ${error.message}`
                    : `Error al registrar colación para trabajador ID: ${idTrabajadorSeleccionado} - ${error.message}`,
                Estado: 'Fallo'
            });

            Swal.fire({
                title: 'Error',
                text: 'No se pudo registrar la colación. Intente nuevamente.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const mostrarModalImportacion = () => {
        const trabajadoresOptions = trabajadores
            .filter(t => t.ID_Trabajador !== idTrabajadorSeleccionado)
            .map(t => `<option value="${t.ID_Trabajador}">${t.Nombres} ${t.Apellidos}</option>`)
            .join('');

        Swal.fire({
            title: 'Importar colación a otros trabajadores',
            html: `
                <div style="text-align: left; margin: 20px 0;">
                    <p><strong>Datos a importar:</strong></p>
                    <ul style="text-align: left; display: inline-block;">
                        <li><strong>Fecha Entrega:</strong> ${fechaEntrega}</li>
                        <li><strong>Tipo:</strong> ${tipoColacion}</li>
                    </ul>
                </div>
                <select id="trabajadores-select" multiple style="width: 100%; height: 200px;" class="form-control">
                    ${trabajadoresOptions}
                </select>
                <p style="margin-top: 10px; font-size: 0.9em; color: #666;">
                    Mantenga presionado Ctrl para seleccionar múltiples trabajadores
                </p>
            `,
            showCancelButton: true,
            confirmButtonText: 'Importar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                const select = document.getElementById('trabajadores-select');
                const selectedOptions = Array.from(select.selectedOptions).map(option => parseInt(option.value));

                if (selectedOptions.length === 0) {
                    Swal.showValidationMessage('Debe seleccionar al menos un trabajador');
                    return false;
                }

                return selectedOptions;
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                await importarColacionesMultiples(result.value);
            }
        });
    };

    const importarColacionesMultiples = async (trabajadoresSeleccionados) => {
        try {
            await Axios.post(`${config.API_URL}/registraColacionesMultiples`, {
                trabajadores: trabajadoresSeleccionados,
                FechaEntrega: fechaEntrega,
                TipoColacion: tipoColacion,
                UsuarioCrea: cookies.usuario,
                userId
            });

            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Colaciones',
                Detalle: `Importación múltiple de colaciones a ${trabajadoresSeleccionados.length} trabajadores`,
                Estado: 'Éxito'
            });

            Swal.fire({
                title: '¡Éxito!',
                text: `Se han registrado las colaciones para ${trabajadoresSeleccionados.length} trabajadores adicionales.`,
                icon: 'success',
                confirmButtonText: 'OK'
            });

            limpiarFormulario();
            cargaResumenMes();

        } catch (error) {
            console.error("Error al importar colaciones múltiples:", error);

            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Colaciones',
                Detalle: `Error en importación múltiple de colaciones - ${error.message}`,
                Estado: 'Fallo'
            });

            Swal.fire({
                title: 'Error',
                text: 'No se pudieron registrar todas las colaciones. Intente nuevamente.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const cargaColaciones = (ID) => {
        if (!ID) return;

        Axios.get(`${config.API_URL}/cargaColaciones?idTrabajador=${ID}&userId=${userId}`)
            .then((response) => {
                const datos = Array.isArray(response.data) ? response.data : [];
                setListadoColaciones(datos);
                console.log("Colaciones cargadas:", datos);
            })
            .catch((error) => {
                console.error("Error al cargar colaciones:", error);
                setListadoColaciones([]);
            });
    };

    const cargaColacionesVisitas = () => {
        Axios.get(`${config.API_URL}/cargaColacionesVisitas?userId=${userId}`)
            .then((response) => {
                const datos = Array.isArray(response.data) ? response.data : [];
                setListadoColaciones(datos);
                console.log("Colaciones de visitas cargadas:", datos);
            })
            .catch((error) => {
                console.error("Error al cargar colaciones de visitas:", error);
                setListadoColaciones([]);
            });
    };

    const cargaColacionesTodas = (incluirVisitas) => {
        const endpoint = incluirVisitas ? 'cargaColacionesTodas' : 'cargaColacionesTodosTrabajadores';
        Axios.get(`${config.API_URL}/${endpoint}?idEmpresa=${idEmpresa}&userId=${userId}`)
            .then((response) => {
                const datos = Array.isArray(response.data) ? response.data : [];
                setListadoColaciones(datos);
                console.log(`Colaciones de todos los ${incluirVisitas ? 'trabajadores + visitas' : 'trabajadores'} cargadas:`, datos);
            })
            .catch((error) => {
                console.error("Error al cargar todas las colaciones:", error);
                setListadoColaciones([]);
            });
    };

    const cargaResumenMes = () => {
        Axios.get(`${config.API_URL}/cargaColacionesTodas?idEmpresa=${idEmpresa}&userId=${userId}`)
            .then((response) => {
                const datos = Array.isArray(response.data) ? response.data : [];
                const hoy = new Date();
                const delMes = datos.filter(colacion => {
                    const fecha = new Date(colacion.FechaEntrega);
                    return fecha.getMonth() === hoy.getMonth() && fecha.getFullYear() === hoy.getFullYear();
                });
                setResumenMes({
                    normal: delMes.filter(c => c.TipoColacion === 'Colación').length,
                    fria: delMes.filter(c => c.TipoColacion === 'Colación Fría').length
                });
            })
            .catch((error) => {
                console.error("Error al cargar el resumen del mes:", error);
            });
    };

    const filtrarColacionesPorMes = () => {
        if (!listadoColaciones || listadoColaciones.length === 0) {
            setListadoColacionesFiltradas([]);
            return;
        }

        // Si mesSeleccionado es 0, mostrar todos los registros
        if (mesSeleccionado === 0) {
            setListadoColacionesFiltradas(listadoColaciones);
            return;
        }

        const filtradas = listadoColaciones.filter(colacion => {
            const fechaEntrega = new Date(colacion.FechaEntrega);
            return fechaEntrega.getMonth() + 1 === mesSeleccionado &&
                fechaEntrega.getFullYear() === anioSeleccionado;
        });

        setListadoColacionesFiltradas(filtradas);
    };

    const eliminarColacion = async (idColacion) => {
        try {
            const result = await Swal.fire({
                title: '¿Está seguro?',
                text: 'Esta acción eliminará permanentemente la colación.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            });

            if (result.isConfirmed) {
                await Axios.delete(`${config.API_URL}/eliminaColacion/${idColacion}`, { params: { userId } });

                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'Colaciones',
                    Detalle: `Eliminación de colación ID: ${idColacion}`,
                    Estado: 'Éxito'
                });

                Swal.fire('Eliminada', 'La colación ha sido eliminada.', 'success');

                // Recargar la lista correspondiente según el modo
                if (modoVisitas) {
                    cargaColacionesVisitas();
                } else {
                    cargaColaciones(idTrabajadorSeleccionado);
                }
            }
        } catch (error) {
            console.error("Error al eliminar colación:", error);

            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Colaciones',
                Detalle: `Error al eliminar colación ID: ${idColacion} - ${error.message}`,
                Estado: 'Fallo'
            });

            Swal.fire('Error', 'No se pudo eliminar la colación.', 'error');
        }
    };

    // Editar un registro ya guardado. Sobre una colación que vino del bot, esto
    // además la marca como editada a mano: desde ese momento la sincronización
    // deja de sobrescribirla, aunque WhatsApp siga informando otra cosa.
    const editarColacion = async (colacion) => {
        const esVisita = colacion.EsVisita === 1 || colacion.ID_Trabajador === -1;
        const fechaActual = new Date(colacion.FechaEntrega).toLocaleDateString('en-CA');

        const avisoBot = colacion.Origen === 'bot' && colacion.EditadoManual !== 1
            ? `<div class="alert alert-warning py-2" style="font-size:.85em;text-align:left;">
                   Este registro vino de la votación de WhatsApp. Al guardarlo a mano,
                   la sincronización del bot dejará de modificarlo.
               </div>`
            : '';

        const { value, isConfirmed } = await Swal.fire({
            title: 'Editar colación',
            html: `
                ${avisoBot}
                <div style="text-align:left;">
                    <label style="display:block;margin-bottom:4px;">Fecha de entrega</label>
                    <input type="date" id="edit-fecha" class="form-control" value="${fechaActual}" />

                    <label style="display:block;margin:12px 0 4px;">Tipo</label>
                    <select id="edit-tipo" class="form-control">
                        <option value="Colación"${colacion.TipoColacion === 'Colación' ? ' selected' : ''}>Colación</option>
                        <option value="Colación Fría"${colacion.TipoColacion === 'Colación Fría' ? ' selected' : ''}>Colación Fría</option>
                    </select>

                    ${esVisita ? `
                    <label style="display:block;margin:12px 0 4px;">Nombre de la visita</label>
                    <input type="text" id="edit-visita" class="form-control" value="${colacion.NombreVisita || ''}" />` : ''}
                </div>`,
            showCancelButton: true,
            confirmButtonText: 'Guardar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                const fecha = document.getElementById('edit-fecha').value;
                const tipo = document.getElementById('edit-tipo').value;
                const visita = esVisita ? document.getElementById('edit-visita').value : null;

                if (!fecha || !tipo) {
                    Swal.showValidationMessage('La fecha y el tipo son obligatorios');
                    return false;
                }
                if (esVisita && !visita) {
                    Swal.showValidationMessage('Debe indicar el nombre de la visita');
                    return false;
                }
                return { FechaEntrega: fecha, TipoColacion: tipo, NombreVisita: visita };
            }
        });

        if (!isConfirmed || !value) return;

        try {
            await Axios.put(`${config.API_URL}/actualizaColacion/${colacion.ID_Colacion}`, {
                ...value,
                UsuarioCrea: cookies.usuario,
                userId
            });

            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Colaciones',
                Detalle: `Edición manual de colación ID: ${colacion.ID_Colacion}`,
                Estado: 'Éxito'
            });

            Swal.fire('Guardada', 'La colación fue actualizada.', 'success');
            recargarListado();
        } catch (error) {
            console.error("Error al actualizar colación:", error);

            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Colaciones',
                Detalle: `Error al editar colación ID: ${colacion.ID_Colacion} - ${error.message}`,
                Estado: 'Fallo'
            });

            Swal.fire('Error', 'No se pudo actualizar la colación.', 'error');
        }
    };

    // Recarga la lista que esté a la vista, sea cual sea el modo.
    const recargarListado = () => {
        if (modoVisitas) cargaColacionesVisitas();
        else if (verTodosTrabajadores) cargaColacionesTodas(tipoDatos === 'trabajadores_visitas');
        else if (idTrabajadorSeleccionado) cargaColaciones(idTrabajadorSeleccionado);
    };

    const limpiarFormulario = () => {
        setFechaEntrega('');
        setTipoColacion('');
        setNombreVisitante('');
    };

    const formatearMonto = (valor) => {
        if (!valor || parseFloat(valor) === 0) {
            return 'Sin monto';
        }
        return parseFloat(valor).toLocaleString('es-CL');
    };

    const formatearFecha = (fecha) => {
        return new Date(fecha).toLocaleDateString('es-CL');
    };

    // El nombre de la visita vive en su propia columna. Para registros
    // anteriores a la migración el backend lo reconstruye desde el texto
    // 'VISITA: <nombre>' archivado, así que aquí llega ya resuelto.
    const nombrePersona = (colacion) => {
        if (colacion.EsVisita === 1 || colacion.ID_Trabajador === -1) {
            return colacion.NombreVisita || 'Visita sin nombre';
        }
        return colacion.NombreTrabajador || 'Sin nombre';
    };

    const tieneHistorico = (colacion) =>
        Boolean(colacion.MotivoHistorico) ||
        (colacion.MontoHistorico !== null && colacion.MontoHistorico !== undefined &&
            parseFloat(colacion.MontoHistorico) > 0);

    // Monto y Motivo salieron del modelo, pero los valores que ya estaban
    // cargados se conservan y se pueden consultar aquí.
    const verHistorico = (colacion) => {
        Swal.fire({
            title: 'Datos históricos del registro',
            html: `
                <div style="text-align:left;">
                    <p class="text-muted" style="font-size:.85em;">
                        Campos que este módulo dejó de usar. Se conservan para los
                        registros cargados antes del cambio.
                    </p>
                    <p><strong>Motivo:</strong> ${colacion.MotivoHistorico || '—'}</p>
                    <p><strong>Monto:</strong> ${colacion.MontoHistorico && parseFloat(colacion.MontoHistorico) > 0
                        ? '$' + formatearMonto(colacion.MontoHistorico)
                        : 'Sin monto'}</p>
                </div>`,
            icon: 'info',
            confirmButtonText: 'Cerrar'
        });
    };

    const manejarExportacion = async () => {
        await mostrarModalExportacion(
            listadoColaciones,
            anioSeleccionado,
            ({ formato, mesesSeleccionados, anio, trabajadoresSeleccionados }) => {
                // Filtrar datos según los meses y trabajadores seleccionados
                let datosParaExportar = listadoColaciones;

                // Filtrar por meses
                if (!mesesSeleccionados.includes(0)) {
                    datosParaExportar = datosParaExportar.filter(colacion => {
                        const fecha = new Date(colacion.FechaEntrega);
                        return mesesSeleccionados.includes(fecha.getMonth() + 1) &&
                            fecha.getFullYear() === anio;
                    });
                } else {
                    datosParaExportar = datosParaExportar.filter(colacion => {
                        const fecha = new Date(colacion.FechaEntrega);
                        return fecha.getFullYear() === anio;
                    });
                }

                // Filtrar por trabajadores si se seleccionaron específicos
                if (trabajadoresSeleccionados && trabajadoresSeleccionados.length > 0 && !trabajadoresSeleccionados.includes(0)) {
                    datosParaExportar = datosParaExportar.filter(colacion => {
                        return trabajadoresSeleccionados.includes(colacion.ID_Trabajador);
                    });
                }

                // Excluir visitas si estamos en modo solo trabajadores
                if (verTodosTrabajadores && tipoDatos === 'trabajadores') {
                    datosParaExportar = datosParaExportar.filter(colacion => colacion.ID_Trabajador !== -1);
                }

                if (datosParaExportar.length === 0) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Sin datos',
                        text: 'No hay colaciones registradas para el período seleccionado.',
                        confirmButtonColor: '#3085d6'
                    });
                    return;
                }

                // Preparar columnas y filas
                // Las columnas históricas solo aparecen si hay algo que mostrar,
                // para no ensuciar el reporte de los periodos posteriores al cambio.
                const hayHistorico = datosParaExportar.some(tieneHistorico);
                const columnasHistoricas = hayHistorico ? ['Motivo (histórico)', 'Monto (histórico)'] : [];

                const columnas = verTodosTrabajadores || (trabajadoresSeleccionados && trabajadoresSeleccionados.includes(0))
                    ? ['N°', 'Fecha Entrega', 'Trabajador/Visita', 'Tipo', 'Origen', 'Usuario Crea', 'Fecha Registro', ...columnasHistoricas]
                    : ['N°', 'Fecha Entrega', 'Tipo', 'Origen', 'Usuario Crea', 'Fecha Registro', ...columnasHistoricas];

                const filas = datosParaExportar.map((colacion, index) => {
                    const filasBase = [
                        index + 1,
                        formatearFecha(colacion.FechaEntrega)
                    ];

                    if (verTodosTrabajadores || (trabajadoresSeleccionados && trabajadoresSeleccionados.includes(0))) {
                        filasBase.push(nombrePersona(colacion));
                    }

                    filasBase.push(
                        colacion.TipoColacion,
                        colacion.Origen === 'bot' ? 'WhatsApp' : 'Manual',
                        colacion.UsuarioCrea,
                        formatearFecha(colacion.FechaCreacion)
                    );

                    if (hayHistorico) {
                        filasBase.push(
                            colacion.MotivoHistorico || '',
                            colacion.MontoHistorico && parseFloat(colacion.MontoHistorico) > 0
                                ? `$${formatearMonto(colacion.MontoHistorico)}`
                                : ''
                        );
                    }

                    return filasBase;
                });

                // Hoja de resumen para Excel: totales por tipo y detalle por persona
                const contar = (lista, tipo) => lista.filter(c => c.TipoColacion === tipo).length;
                const porPersona = {};
                datosParaExportar.forEach(colacion => {
                    const clave = colacion.ID_Trabajador === -1
                        ? `v:${nombrePersona(colacion)}`
                        : `t:${colacion.ID_Trabajador}`;
                    if (!porPersona[clave]) {
                        porPersona[clave] = { nombre: nombrePersona(colacion), colaciones: [] };
                    }
                    porPersona[clave].colaciones.push(colacion);
                });
                const totalNormal = contar(datosParaExportar, 'Colación');
                const totalFria = contar(datosParaExportar, 'Colación Fría');
                const hojaResumen = {
                    nombre: 'Resumen',
                    anchos: [35, 15, 15, 15],
                    filas: [
                        ['RESUMEN DE COLACIONES'],
                        [''],
                        ['Tipo', 'Cantidad'],
                        ['Colación', totalNormal],
                        ['Colación Fría', totalFria],
                        ['Total', datosParaExportar.length],
                        [''],
                        ['Trabajador/Visita', 'Colación', 'Colación Fría', 'Total'],
                        ...Object.values(porPersona)
                            .sort((a, b) => a.nombre.localeCompare(b.nombre, 'es'))
                            .map(p => [
                                p.nombre,
                                contar(p.colaciones, 'Colación'),
                                contar(p.colaciones, 'Colación Fría'),
                                p.colaciones.length
                            ]),
                        ['TOTAL', totalNormal, totalFria, datosParaExportar.length]
                    ]
                };

                const nombreTrabajadorTexto = verTodosTrabajadores || (trabajadoresSeleccionados && trabajadoresSeleccionados.includes(0))
                    ? `Todos_${tipoDatos === 'trabajadores_visitas' ? 'Trabajadores_Visitas' : 'Trabajadores'}`
                    : nombreTrabajadorSeleccionado.replace(/ /g, '_');

                const configuracion = {
                    titulo: 'REPORTE DE COLACIONES',
                    nombreArchivo: `Colaciones_${nombreTrabajadorTexto}_${anio}.${formato === 'pdf' ? 'pdf' : 'xlsx'}`,
                    selectedCard: cookies.selectedCard,
                    empresa,
                    columnas,
                    filas,
                    nombreTrabajador: verTodosTrabajadores || (trabajadoresSeleccionados && trabajadoresSeleccionados.includes(0))
                        ? `Todos los ${tipoDatos === 'trabajadores_visitas' ? 'trabajadores + visitas' : 'trabajadores'}`
                        : nombreTrabajadorSeleccionado,
                    mesesSeleccionados,
                    anioSeleccionado: anio,
                    hojasAdicionales: [hojaResumen]
                };

                if (formato === 'pdf') {
                    exportarAPDF(datosParaExportar, configuracion);
                } else {
                    exportarAExcel(datosParaExportar, configuracion);
                }
            },
            trabajadores,
            verTodosTrabajadores
        );
    };

    useEffect(() => {
        getTrabajadores();
    }, []);

    useEffect(() => {
        filtrarColacionesPorMes();
    }, [listadoColaciones, mesSeleccionado, anioSeleccionado]);

    // El listado se recarga tras cada registro, edición o eliminación,
    // así que el resumen se refresca junto con él (y también al montar).
    useEffect(() => {
        cargaResumenMes();
    }, [listadoColaciones]);

    useEffect(() => {
        if (listadoColacionesFiltradas.length > 0) {
            if (window.$ && window.$.fn.dataTable) {
                setTimeout(() => {
                    if (!window.$.fn.dataTable.isDataTable('#colacionesTable')) {
                        window.$('#colacionesTable').DataTable({
                            language: {
                                url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/Spanish.json'
                            },
                            order: [[1, 'desc']],
                            pageLength: 10,
                            responsive: true
                        });
                    }
                }, 100);
            }
        }

        return () => {
            if (window.$ && window.$.fn.dataTable && window.$.fn.dataTable.isDataTable('#colacionesTable')) {
                window.$('#colacionesTable').DataTable().destroy();
            }
        };
    }, [listadoColacionesFiltradas]);

    return (
        <body id="page-top">
            <div id="wrapper">
                <Sidebar
                    imageUrl={imageUrl}
                    isComponentsCollapsed={isComponentsCollapsed}
                    toggleCollapse={toggleCollapse}
                    setIsComponentsCollapsed={setIsComponentsCollapsed}
                    isUtilitiesCollapsed={isUtilitiesCollapsed}
                    setIsUtilitiesCollapsed={setIsUtilitiesCollapsed}
                    isInventario={isInventario}
                    setisIventatioCollapsed={setisIventatioCollapsed}
                    isPrevencion={isPrevencion}
                    setisPrevencionCollapsed={setisPrevencionCollapsed}
                    isLogistica={isLogistica}
                    setisLogisticaCollapsed={setisLogisticaCollapsed}
                    isContabilidadCollapsed={isContabilidadCollapsed}
                    setIsContabilidadCollapsed={setIsContabilidadCollapsed}
                    isAdministracionCollapsed={isAdministracionCollapsed}
                    setIsAdministracionCollapsed={setIsAdministracionCollapsed}
                    cookies={cookies}
                />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card shadow mb-4">
                                        <div className="card-header py-3">
                                            <h6 className="m-0 font-weight-bold text-primary">Módulo Colaciones de {empresa}</h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="row mb-3">
                                                <div className="col-md-6 mb-3 mb-md-0">
                                                    <div className="card border-left-primary shadow h-100 py-2">
                                                        <div className="card-body">
                                                            <div className="row no-gutters align-items-center">
                                                                <div className="col mr-2">
                                                                    <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                                        Colaciones del mes ({new Date().toLocaleDateString('es-CL', { month: 'long', year: 'numeric' })})
                                                                    </div>
                                                                    <div className="h5 mb-0 font-weight-bold text-gray-800">{resumenMes.normal}</div>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <i className="fas fa-utensils fa-2x text-gray-300"></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="card border-left-info shadow h-100 py-2">
                                                        <div className="card-body">
                                                            <div className="row no-gutters align-items-center">
                                                                <div className="col mr-2">
                                                                    <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                                                                        Colaciones frías del mes ({new Date().toLocaleDateString('es-CL', { month: 'long', year: 'numeric' })})
                                                                    </div>
                                                                    <div className="h5 mb-0 font-weight-bold text-gray-800">{resumenMes.fria}</div>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <i className="fas fa-snowflake fa-2x text-gray-300"></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <ColacionesBot
                                                idEmpresa={idEmpresa}
                                                userId={userId}
                                                usuario={cookies.usuario}
                                                trabajadores={trabajadores}
                                                onCambio={recargarListado}
                                            />

                                            <div className="mb-3">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label className="font-weight-bold text-primary">Modo de vista:</label>
                                                            <select
                                                                className="form-control"
                                                                value={
                                                                    modoVisitas
                                                                        ? 'solo_visitas'
                                                                        : verTodosTrabajadores
                                                                            ? (tipoDatos === 'trabajadores_visitas' ? 'todos_con_visitas' : 'todos_trabajadores')
                                                                            : 'individual'
                                                                }
                                                                onChange={(e) => {
                                                                    const valor = e.target.value;
                                                                    if (valor === 'individual') {
                                                                        setModoVisitas(false);
                                                                        setVerTodosTrabajadores(false);
                                                                        setListadoColaciones([]);
                                                                        limpiarFormulario();
                                                                    } else if (valor === 'solo_visitas') {
                                                                        setModoVisitas(true);
                                                                        setVerTodosTrabajadores(false);
                                                                        setSeleccion(true);
                                                                        cargaColacionesVisitas();
                                                                        limpiarFormulario();
                                                                    } else if (valor === 'todos_trabajadores') {
                                                                        setModoVisitas(false);
                                                                        setVerTodosTrabajadores(true);
                                                                        setTipoDatos('trabajadores');
                                                                        cargaColacionesTodas(false);
                                                                    } else if (valor === 'todos_con_visitas') {
                                                                        setModoVisitas(false);
                                                                        setVerTodosTrabajadores(true);
                                                                        setTipoDatos('trabajadores_visitas');
                                                                        cargaColacionesTodas(true);
                                                                    }
                                                                }}
                                                            >
                                                                <option value="individual">Individual (seleccionar trabajador)</option>
                                                                <option value="solo_visitas">Solo Visitas</option>
                                                                <option value="todos_trabajadores">Todos los Trabajadores</option>
                                                                <option value="todos_con_visitas">Trabajadores + Visitas</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                {!modoVisitas && !verTodosTrabajadores && (
                                                    <>
                                                        <div className="col-md-4">
                                                            <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                                Trabajador:
                                                            </div>
                                                            <select
                                                                className="form-control"
                                                                value={idTrabajadorSeleccionado}
                                                                onChange={(e) => {
                                                                    const selectedId = e.target.value;
                                                                    const selectedWorker = trabajadores.find(t => t.ID_Trabajador == selectedId);
                                                                    if (selectedWorker) {
                                                                        seleccionTrue(selectedId, `${selectedWorker.Nombres} ${selectedWorker.Apellidos}`);
                                                                    }
                                                                }}
                                                            >
                                                                <option value="">Seleccione un trabajador:</option>
                                                                {trabajadores.map((trabajador) => (
                                                                    <option key={trabajador.ID_Trabajador} value={trabajador.ID_Trabajador}>
                                                                        {trabajador.Nombres} {trabajador.Apellidos}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        <div className="col-md-8 d-flex align-items-end">
                                                            <div className="card border-left-info shadow h-auto py-2 w-100">
                                                                <div className="card-body py-2">
                                                                    <div className="row no-gutters align-items-center">
                                                                        <div className="col">
                                                                            <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                                                                                Trabajador seleccionado
                                                                            </div>
                                                                            <div className="h6 mb-0 font-weight-bold text-gray-800">
                                                                                {nombreTrabajadorSeleccionado || 'Ninguno'}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-auto">
                                                                            <i className="fas fa-user-check fa-2x text-gray-300"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>

                                            {(seleccion || modoVisitas) && (
                                                <div className="row mt-4">
                                                    <div className="col-md-12">
                                                        <h6 className="m-0 font-weight-bold text-primary mb-3">Registrar Colación</h6>
                                                        <form>
                                                            <div className="row">
                                                                <div className="col-md-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="fechaEntrega">Fecha de Entrega:</label>
                                                                        <input
                                                                            type="date"
                                                                            className="form-control"
                                                                            id="fechaEntrega"
                                                                            value={fechaEntrega}
                                                                            onChange={(e) => setFechaEntrega(e.target.value)}
                                                                            required
                                                                        />
                                                                    </div>
                                                                </div>

                                                                {modoVisitas && (
                                                                    <div className="col-md-3">
                                                                        <div className="form-group">
                                                                            <label htmlFor="nombreVisitante">Nombre de la Visita:</label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                id="nombreVisitante"
                                                                                placeholder="Ingrese nombre completo"
                                                                                value={nombreVisitante}
                                                                                onChange={(e) => setNombreVisitante(e.target.value)}
                                                                                required
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                <div className="col-md-2">
                                                                    <div className="form-group">
                                                                        <label htmlFor="tipoColacion">Tipo:</label>
                                                                        <select
                                                                            className="form-control"
                                                                            id="tipoColacion"
                                                                            value={tipoColacion}
                                                                            onChange={(e) => setTipoColacion(e.target.value)}
                                                                            required
                                                                        >
                                                                            <option value="">Seleccione</option>
                                                                            <option value="Colación">Colación</option>
                                                                            <option value="Colación Fría">Colación Fría</option>
                                                                        </select>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-2 d-flex align-items-end">
                                                                    <div className="form-group w-100">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary btn-block"
                                                                            onClick={RegistraColacion}
                                                                        >
                                                                            <i className="fas fa-plus"></i> Registrar
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            )}

                                            {seleccion && (
                                                <div className="col-md-12 mt-4">
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <h6 className="m-0 font-weight-bold text-primary">
                                                            {modoVisitas
                                                                ? 'Historial de Colaciones de Visitas'
                                                                : verTodosTrabajadores
                                                                    ? `Historial de Colaciones - Todos los ${tipoDatos === 'trabajadores_visitas' ? 'Trabajadores + Visitas' : 'Trabajadores'}`
                                                                    : 'Historial de Colaciones'}
                                                        </h6>
                                                        <div className="d-flex align-items-center">
                                                            <button
                                                                className="btn btn-success btn-sm"
                                                                onClick={manejarExportacion}
                                                                title="Exportar datos"
                                                                style={{ marginRight: '20px' }}
                                                            >
                                                                <i className="fas fa-download"></i> Exportar
                                                            </button>
                                                            <label className="mb-0 mr-2">Filtrar por:</label>
                                                            <select
                                                                className="form-control form-control-sm mr-2"
                                                                style={{ width: '120px' }}
                                                                value={mesSeleccionado}
                                                                onChange={(e) => setMesSeleccionado(parseInt(e.target.value))}
                                                            >
                                                                <option value="0">TOTAL</option>
                                                                <option value="1">Enero</option>
                                                                <option value="2">Febrero</option>
                                                                <option value="3">Marzo</option>
                                                                <option value="4">Abril</option>
                                                                <option value="5">Mayo</option>
                                                                <option value="6">Junio</option>
                                                                <option value="7">Julio</option>
                                                                <option value="8">Agosto</option>
                                                                <option value="9">Septiembre</option>
                                                                <option value="10">Octubre</option>
                                                                <option value="11">Noviembre</option>
                                                                <option value="12">Diciembre</option>
                                                            </select>
                                                            <select
                                                                className="form-control form-control-sm"
                                                                style={{ width: '100px' }}
                                                                value={anioSeleccionado}
                                                                onChange={(e) => setAnioSeleccionado(parseInt(e.target.value))}
                                                            >
                                                                {[...Array(5)].map((_, i) => {
                                                                    const year = new Date().getFullYear() - i;
                                                                    return <option key={year} value={year}>{year}</option>;
                                                                })}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    {listadoColacionesFiltradas.length > 0 ? (
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered" id="colacionesTable" width="100%" cellSpacing="0">
                                                                <thead>
                                                                    <tr>
                                                                        <th>N°</th>
                                                                        <th>Fecha Entrega</th>
                                                                        {(verTodosTrabajadores || modoVisitas) && <th>{modoVisitas ? 'Nombre Visita' : 'Trabajador/Visita'}</th>}
                                                                        <th>Tipo</th>
                                                                        <th>Origen</th>
                                                                        <th>Usuario Crea</th>
                                                                        <th>Fecha Registro</th>
                                                                        <th>Acciones</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {Array.isArray(listadoColacionesFiltradas) && listadoColacionesFiltradas.map((colacion, index) => (
                                                                        <tr key={colacion.ID_Colacion}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{formatearFecha(colacion.FechaEntrega)}</td>
                                                                            {(verTodosTrabajadores || modoVisitas) && (
                                                                                <td>{nombrePersona(colacion)}</td>
                                                                            )}
                                                                            <td>{colacion.TipoColacion}</td>
                                                                            <td>
                                                                                <span className={`badge ${colacion.Origen === 'bot' ? 'badge-success' : 'badge-secondary'}`}>
                                                                                    {colacion.Origen === 'bot' ? 'WhatsApp' : 'Manual'}
                                                                                </span>
                                                                                {colacion.EditadoManual === 1 && (
                                                                                    <span className="badge badge-warning ml-1"
                                                                                        title="Editado a mano: la sincronización del bot ya no lo sobrescribe">
                                                                                        editado
                                                                                    </span>
                                                                                )}
                                                                            </td>
                                                                            <td>{colacion.UsuarioCrea}</td>
                                                                            <td>{formatearFecha(colacion.FechaCreacion)}</td>
                                                                            <td>
                                                                                {tieneHistorico(colacion) && (
                                                                                    <button
                                                                                        className="btn btn-info btn-sm mr-1"
                                                                                        onClick={() => verHistorico(colacion)}
                                                                                        title="Ver motivo y monto históricos"
                                                                                    >
                                                                                        <i className="fas fa-info-circle"></i>
                                                                                    </button>
                                                                                )}
                                                                                <button
                                                                                    className="btn btn-warning btn-sm mr-1"
                                                                                    onClick={() => editarColacion(colacion)}
                                                                                    title={colacion.Origen === 'bot' && colacion.EditadoManual !== 1
                                                                                        ? 'Editar (el bot dejará de sobrescribir este registro)'
                                                                                        : 'Editar colación'}
                                                                                >
                                                                                    <i className="fas fa-pen"></i>
                                                                                </button>
                                                                                <button
                                                                                    className="btn btn-danger btn-sm"
                                                                                    onClick={() => eliminarColacion(colacion.ID_Colacion)}
                                                                                    title="Eliminar colación"
                                                                                >
                                                                                    <i className="fas fa-trash"></i>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        <div className="alert alert-info text-center">
                                                            <i className="fas fa-info-circle"></i>
                                                            <strong>
                                                                {modoVisitas
                                                                    ? `No hay colaciones registradas para visitas`
                                                                    : nombreTrabajadorSeleccionado
                                                                        ? `No hay colaciones registradas para ${nombreTrabajadorSeleccionado}`
                                                                        : 'Seleccione un trabajador para ver su historial de colaciones'
                                                                }
                                                                {mesSeleccionado === 0 ? '' : ` en ${['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'][mesSeleccionado - 1]} de ${anioSeleccionado}`}
                                                            </strong>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </body>
    );
}

export default Colaciones;